<template>
  <div class="presentation-quality-control">
    <SpellcheckerAlert />
  </div>
</template>

<script>
import SpellcheckerAlert from '@/components-v2/presentation-editor/editor-header/quality-control/SpellcheckerAlert.vue'

export default {
  components: {
    SpellcheckerAlert,
  },
}
</script>

<style lang="scss" scoped>
.presentation-quality-control {
}
</style>
